import { MainApi } from "./MainApi";
import { UserProfile } from "../types/user";

export class ProfileApi {
  static baseUrl = `${MainApi.urlPrefix}/user`;

  static getProfiles = () => () => MainApi.api.get<UserProfile[]>(`${ProfileApi.baseUrl}/profile`);
  static getProfile = (profileIdx: number) => () =>
    MainApi.api.get<UserProfile>(`${ProfileApi.baseUrl}/profile/${profileIdx}`);
}
